export default __webpack_public_path__ + "static/media/logo.4600fec5.png";